const productSearchBar = {
  ePrescription: '(E-)Rezept',
  upload: 'Hochladen',
  label: 'Medikament suchen (Produktname, PZN...)',
  searchAll: 'Alle Ergebnisse für "{search}" anzeigen',
  barcodeText: 'SCAN',
  barcodeScanner: {
    title: 'Barcode scanner',
    text1: 'Wo finde ich den scanbaren Code?',
    text2: 'Der scanbare Code ist meist auf der Seite der Packung abgedruckt und erkennbar an den Buchstaben "PZN".',
    text3: 'Welche Codes können gescannt werden?',
    text4: 'Wir sind spezialisiert auf apothekenübliche Produkte. Andere Produkte werden daher nicht erkannt.',
    text5: 'Was tun, wenn der Code nicht erkannt wird?',
    text6: 'Sollte der Code nicht sofort erkannt werden, bewegen oder kippen Sie die Kamera leicht über dem Code. Sie können auch den Abstand verändern. Achten Sie in jedem Fall auf gute Beleuchtung!',
    text7: 'Melden Sie ein Problem',
    text8: 'Barcode scannen',
    messages: {
      errorReadingBarcode: 'Bitte versuchen Sie es erneut. Der Barcode konnte nicht gelesen werden. Andere Probleme beim Scannen?',
      productNotFound: 'Das Produkt konnte in unserer PZN-Datenbank nicht gefunden werden. Andere Probleme beim Scannen?',
      fileSizeLimit: 'Ihre Datei konnte nicht scannen werden. Ihre Datei übersteigt die Dateigröße von {uploadLimit} MB. Andere Probleme beim Scannen?',
      fileTypeNotSupported: 'Das ausgewählte Dateiformat {type} ist leider ungültig. Bitte wählen Sie eines der folgenden Dateiformate zum Hochladen Ihres Barcode aus: .jpg, .jpeg, .png. Andere Probleme beim Scannen?',
      cameraNotSupported: 'Ups, es sieht so aus, als könnten wir nicht auf Ihre Kamera zugreifen. Bitte aktivieren Sie sie in Ihren Browsereinstellungen oder überprüfen Sie, ob sie richtig angeschlossen ist.',
    },
  },
}

export default productSearchBar
